/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Split_Upper_LowerInputs */

const en_us2_plan_split_upper_lower = /** @type {(inputs: Plan_Split_Upper_LowerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upper / lower`)
};

const pt_br2_plan_split_upper_lower = /** @type {(inputs: Plan_Split_Upper_LowerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Superior / inferior`)
};

const es_419_plan_split_upper_lower = /** @type {(inputs: Plan_Split_Upper_LowerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Superior / inferior`)
};

const pt_pt2_plan_split_upper_lower = /** @type {(inputs: Plan_Split_Upper_LowerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Superior / inferior`)
};

const fr_fr2_plan_split_upper_lower = /** @type {(inputs: Plan_Split_Upper_LowerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haut / bas du corps`)
};

const de_de2_plan_split_upper_lower = /** @type {(inputs: Plan_Split_Upper_LowerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oberkörper / Unterkörper`)
};

const it_it2_plan_split_upper_lower = /** @type {(inputs: Plan_Split_Upper_LowerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Superiore / inferiore`)
};

/**
* | output |
* | --- |
* | "Upper / lower" |
*
* @param {Plan_Split_Upper_LowerInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_split_upper_lower = /** @type {((inputs?: Plan_Split_Upper_LowerInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Split_Upper_LowerInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_split_upper_lower(inputs)
	if (locale === "es-419") return es_419_plan_split_upper_lower(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_split_upper_lower(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_split_upper_lower(inputs)
	if (locale === "de-DE") return de_de2_plan_split_upper_lower(inputs)
	if (locale === "it-IT") return it_it2_plan_split_upper_lower(inputs)
	return en_us2_plan_split_upper_lower(inputs)
});
export { plan_split_upper_lower as "plan.split.upper_lower" }